/**
 * About feature — hovering a store address (left) swaps the map shown
 * in the panel on the right. Each map slide is a link to Google Maps.
 */
(function () {
  function wire(section) {
    const slides = section.querySelectorAll('[data-map]');
    if (slides.length < 1) return;
    const triggers = section.querySelectorAll('[data-map-trigger]');

    function activate(idx) {
      let matched = false;
      slides.forEach((s) => {
        const on = s.getAttribute('data-map') === String(idx);
        s.classList.toggle('is-active', on);
        if (on) matched = true;
      });
      return matched;
    }

    triggers.forEach((t) => {
      const idx = t.getAttribute('data-map-trigger');
      ['mouseenter', 'focusin'].forEach((evt) =>
        t.addEventListener(evt, () => activate(idx), { passive: true })
      );
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.zu-about').forEach(wire);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', () => init());

  // Re-wire when the section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
